import { PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CqModificationsFormSchema } from "pages/CustomQuote/AddQuotePage/components/CQModifications/forms/CQModificationsFormSchema.ts";

const CQModificationsFormProvider = ({ children }: PropsWithChildren) => {
	const formMethods = useForm({
		mode: "onSubmit",
		resolver: yupResolver(CqModificationsFormSchema),
		reValidateMode: "onChange"
	});

	return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default CQModificationsFormProvider;
